/* ================================================================
   LFJ PIXEL NOTIFICATIONS — Checkpoint 62
   ----------------------------------------------------------------
   Replaces the old single Pokémon-dialogue textbox (which, checked
   directly, was the entire "announcement" system on the live site —
   no banner, no corner-ping, no content pool existed before this)
   with the real two-piece system from the master handoff:
     - Top banner   — drops from the top, holds, retracts. Ambient,
                       settings-driven content pool, random interval.
     - Corner ping  — smaller, appears in a screen corner, fades on
                       its own. Also ambient/settings-driven, AND is
                       what window.LFJ_NOTIFY() now renders as for any
                       direct call elsewhere in the theme (e.g. the
                       LFJ room's welcome message in lfj-lfj.js) — that
                       call site needed zero changes, it just looks
                       different now.

   window.LFJ_NOTIFY(message, opts) — unchanged API, still safe to
   call from anywhere once this script has loaded:
     window.LFJ_NOTIFY('New drop just landed.');
     window.LFJ_NOTIFY('Custom hold time', { holdMs: 5000 });
   This direct-call path always fires regardless of whether the
   ambient ping pool is enabled/empty — those settings only gate the
   automatic random rotation below, not explicit calls like this one.
================================================================ */

(function () {
  'use strict';

  function safeRun(label, fn) {
    try { return fn(); } catch (e) { console.warn('[LFJ:' + label + ']', e); return null; }
  }

  /* ── Corner ping (also LFJ_NOTIFY's renderer) ── */
  var cornerBox = null;
  var cornerText = null;
  var cornerHideTimer = null;
  var cornerPosition = 'bottom-right';

  function ensureCornerBox() {
    if (cornerBox) return cornerBox;
    cornerBox = document.createElement('div');
    cornerBox.className = 'lfj-notify lfj-notify--' + cornerPosition;
    cornerBox.setAttribute('role', 'status');
    cornerBox.setAttribute('aria-live', 'polite');

    cornerText = document.createElement('span');
    cornerBox.appendChild(cornerText);

    var arrow = document.createElement('span');
    arrow.className = 'lfj-notify-arrow';
    arrow.textContent = '\u25bc';
    arrow.setAttribute('aria-hidden', 'true');
    cornerBox.appendChild(arrow);

    document.body.appendChild(cornerBox);
    return cornerBox;
  }

  window.LFJ_NOTIFY = function (message, opts) {
    return safeRun('notify', function () {
      opts = opts || {};
      var holdMs = typeof opts.holdMs === 'number' ? opts.holdMs : 3200;

      var el = ensureCornerBox();
      cornerText.textContent = String(message == null ? '' : message);

      if (cornerHideTimer) clearTimeout(cornerHideTimer);
      el.classList.add('is-visible');

      cornerHideTimer = setTimeout(function () {
        el.classList.remove('is-visible');
      }, holdMs);
    });
  };

  /* ── Top banner ── */
  var bannerBox = null;
  var bannerText = null;
  var bannerHideTimer = null;

  function ensureBannerBox() {
    if (bannerBox) return bannerBox;
    bannerBox = document.createElement('div');
    bannerBox.className = 'lfj-notify-banner';
    bannerBox.setAttribute('role', 'status');
    bannerBox.setAttribute('aria-live', 'polite');

    bannerText = document.createElement('span');
    bannerBox.appendChild(bannerText);

    document.body.appendChild(bannerBox);
    return bannerBox;
  }

  function showBanner(message, holdSeconds) {
    var el = ensureBannerBox();
    bannerText.textContent = String(message == null ? '' : message);

    if (bannerHideTimer) clearTimeout(bannerHideTimer);
    el.classList.add('is-visible');

    bannerHideTimer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, (holdSeconds || 4) * 1000);
  }

  /* ── Ambient rotation — shared by both pieces ── */
  function cleanPool(rawMessages) {
    return (rawMessages || [])
      .map(function (s) { return String(s == null ? '' : s).trim(); })
      .filter(function (s) { return s.length > 0; });
  }

  function pickRandom(pool) {
    if (!pool.length) return null;
    return pool[Math.floor(Math.random() * pool.length)];
  }

  function randomDelayMs(minMinutes, maxMinutes) {
    var min = Math.max(0.1, Number(minMinutes) || 1);
    var max = Math.max(min, Number(maxMinutes) || min);
    var minutes = min + Math.random() * (max - min);
    return minutes * 60 * 1000;
  }

  /* Each piece runs its own independent random-interval loop — the
     banner and the corner ping are not synchronized with each other,
     matching "two independent pieces" from the spec. A pool that's
     empty (or only has blank lines) after cleaning simply never
     schedules anything, rather than looping forever showing nothing —
     matches the settings' own "leave blank to disable" wording. */
  function startAmbientLoop(cfg, renderFn) {
    if (!cfg || !cfg.enabled) return;
    var pool = cleanPool(cfg.messages);
    if (!pool.length) return;

    function tick() {
      var msg = pickRandom(pool);
      if (msg) renderFn(msg, cfg.holdSeconds);
      setTimeout(tick, randomDelayMs(cfg.minInterval, cfg.maxInterval));
    }
    setTimeout(tick, randomDelayMs(cfg.minInterval, cfg.maxInterval));
  }

  function init() {
    safeRun('notify-init', function () {
      var notifyCfg = (window.LF_CONFIG && window.LF_CONFIG.notify) || {};
      var cornerCfg = notifyCfg.corner || {};
      cornerPosition = cornerCfg.position || 'bottom-right';

      startAmbientLoop(notifyCfg.banner, showBanner);
      startAmbientLoop(cornerCfg, function (msg, holdSeconds) {
        window.LFJ_NOTIFY(msg, { holdMs: (Number(holdSeconds) || 3) * 1000 });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
